import { Link } from "react-router-dom";
import { C } from "../constants/theme";
import FadeIn from "../components/ui/FadeIn";
import RainbowDivider from "../components/ui/RainbowDivider";

const STAFF = [
  {
    name: "Fareed Ullah",
    role: "Physical Trainer | Martial Arts Coach",
    photo: "/staff/fareed-ullah.jpg",
    color: C.mint,
    credentials: [
      { icon:"🎓", label:"Qualification", text:"BS Software Engineering" },
      { icon:"🥋", label:"Martial Arts", text:"Taekwondo Black Belt — Certified Coach & Referee" },
    ],
    bio: "Fareed is a passionate fitness and martial arts coach who loves helping children build confidence, discipline, coordination, teamwork, and self-control through fun, safe, and structured training. He believes in strengthening both body and character.",
  },
  {
    name: "Zunaira",
    role: "Early Years Educator | Applied Psychologist",
    photo: "/staff/zunaira-ahmad.jpg",
    color: C.coral,
    credentials: [
      { icon:"🎓", label:"Qualification", text:"B.S. (Hons) Applied Psychology" },
    ],
    bio: "Zunaira is a kind, empathetic early years educator who loves working with children. She creates a warm, supportive environment where children feel heard and confident, while nurturing their curiosity, creativity, independence, and individual growth.",
  },
  {
    name: "Maria",
    role: "Early Childhood Teacher | Certified International ABA Therapist",
    photo: "/staff/maria.jpg",
    color: C.navy,
    credentials: [
      { icon:"🎓", label:"Qualification", text:"BS Psychology" },
    ],
    bio: "Maria is a gentle and patient early years educator who believes in nurturing children with love, Islamic values, and meaningful connections. She enjoys encouraging their curiosity, creativity, and confidence through joyful, safe, and child-led learning.",
  },
];

const AboutStaff = () => {
  return (
    <div style={{ paddingTop: 72 }}>
      {/* ── Hero ── */}
      <section style={{ background:`linear-gradient(160deg,${C.mint} 0%,#2d8f75 100%)`, padding:"100px 6vw 90px", position:"relative", overflow:"hidden", minHeight:"46vh", display:"flex", alignItems:"center" }}>
        <div style={{ position:"absolute", top:-80, right:-80, width:400, height:400, borderRadius:"50%", background:"rgba(255,255,255,0.08)", pointerEvents:"none" }}/>
        <div style={{ maxWidth:1100, margin:"0 auto", position:"relative", zIndex:2 }}>
          <div style={{ display:"inline-flex", alignItems:"center", gap:8, background:"rgba(255,255,255,0.2)", color:C.white, fontFamily:"Nunito", fontWeight:700, fontSize:11, letterSpacing:"0.15em", padding:"6px 16px", borderRadius:100, textTransform:"uppercase", marginBottom:20 }}>Our Team</div>
          <h1 style={{ fontFamily:"Fredoka One", fontSize:"clamp(28px,5vw,52px)", color:C.white, lineHeight:1.1, margin:"0 0 18px", maxWidth:640 }}>
            Meet Our Staff.
          </h1>
          <p style={{ fontFamily:"Lora", fontStyle:"italic", fontSize:"clamp(14px,2vw,18px)", color:"rgba(255,255,255,0.88)", maxWidth:600, lineHeight:1.8, margin:0 }}>
            The teachers and coaches behind Mini Muslims Nest — their training, their hearts, and why they chose this work.
          </p>
        </div>
      </section>

      {/* ── Staff Profiles ── */}
      <section style={{ background:C.cream, padding:"90px 6vw" }}>
        <div style={{ maxWidth:900, margin:"0 auto" }}>
          <FadeIn>
            <div style={{ textAlign:"center", marginBottom:48 }}>
              <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:C.coral, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:12 }}>Our Team</div>
              <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(22px,3.5vw,34px)", color:C.navy, margin:0 }}>Faces & Stories.</h2>
              <RainbowDivider />
            </div>
          </FadeIn>

          <div style={{ display:"flex", flexDirection:"column", gap:32 }}>
            {STAFF.map(({ name, role, photo, color, credentials, bio }, i) => (
              <FadeIn key={name} delay={i * 0.1}>
                <div style={{
                  display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(260px,1fr))", gap:32,
                  background:C.white, borderRadius:24, padding:"32px", alignItems:"start",
                  boxShadow:"0 8px 28px rgba(0,0,0,0.06)", border:`2px solid ${color}22`,
                }}>
                  <div style={{ maxWidth:280, margin:"0 auto", width:"100%" }}>
                    <div style={{
                      borderRadius:20, overflow:"hidden", border:`4px solid ${color}`,
                      boxShadow:`0 10px 26px ${color}45`,
                    }}>
                      <img src={photo} alt={name} style={{ width:"100%", display:"block", aspectRatio:"3/4", objectFit:"cover" }} />
                    </div>
                  </div>
                  <div>
                    <div style={{ fontFamily:"Fredoka One", fontSize:26, color:C.navy, marginBottom:6 }}>{name}</div>
                    <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12.5, color, textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:20 }}>{role}</div>
                    <div style={{ display:"flex", flexDirection:"column", gap:12, marginBottom:20 }}>
                      {credentials.map(({ icon, label, text }) => (
                        <div key={label} style={{ display:"flex", gap:10, alignItems:"flex-start" }}>
                          <span style={{ fontSize:17, flexShrink:0 }}>{icon}</span>
                          <span style={{ fontFamily:"Nunito", fontSize:13.5, color:C.text, lineHeight:1.6 }}>
                            <b style={{ color:C.navy }}>{label}:</b> {text}
                          </span>
                        </div>
                      ))}
                    </div>
                    <p style={{ fontFamily:"Lora", fontSize:14, color:C.text, lineHeight:1.85, margin:0 }}>{bio}</p>
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* ── Also Explore ── */}
      <section style={{ background:C.cream, padding:"0 6vw 70px" }}>
        <div style={{ maxWidth:640, margin:"0 auto", textAlign:"center", display:"flex", gap:20, justifyContent:"center", flexWrap:"wrap" }}>
          <Link to="/about/story" style={{ fontFamily:"Nunito", fontWeight:700, fontSize:13.5, color:C.navy, textDecoration:"none" }}>Our Story →</Link>
          <Link to="/about" style={{ fontFamily:"Nunito", fontWeight:700, fontSize:13.5, color:C.navy, textDecoration:"none" }}>Meet Our Founder →</Link>        </div>
      </section>

      {/* ── CTA ── */}
      <section style={{ background:C.warmGray, padding:"70px 6vw" }}>
        <div style={{ maxWidth:560, margin:"0 auto", textAlign:"center" }}>
          <FadeIn>
            <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(20px,3vw,30px)", color:C.navy, margin:"0 0 14px" }}>Have Questions About Our Team?</h2>
            <div style={{ display:"flex", gap:12, justifyContent:"center", flexWrap:"wrap" }}>
              <a href="https://wa.me/923390002106" target="_blank" rel="noopener noreferrer" style={{ background:"#25D366", color:C.white, textDecoration:"none", fontFamily:"Nunito", fontWeight:700, fontSize:13.5, padding:"12px 26px", borderRadius:100 }}>💬 Ask on WhatsApp</a>
              <Link to="/admissions#interest-form" style={{ background:"transparent", color:C.navy, textDecoration:"none", fontFamily:"Nunito", fontWeight:700, fontSize:13.5, padding:"12px 26px", borderRadius:100, border:`2px solid ${C.navy}` }}>Enroll Your Child</Link>
            </div>
          </FadeIn>
        </div>
      </section>
    </div>
  );
};

export default AboutStaff;
